import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ArticleCreateFormContainer from "./createFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateArticleDialog() {
  const getCreateDialog = (onSubmitSuccess?: () => void): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Article),
      titleIcon: IconDefinitionConstants.WBox,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Create),
          successMessage: TranslationKeys.Article.ArticleCreateSuccess,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <ArticleCreateFormContainer />,
      maxWidth: "sm",
      onSubmit: onSubmitSuccess,
    };
  };

  return getCreateDialog;
}

export default useCreateArticleDialog;
